'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_table$package$$anon$4(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_table$package$$anon$4 as $c_Lpresto_table$package$$anon$4 };
$p = $c_Lpresto_table$package$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_table$package$$anon$4;
/** @constructor */
function $h_Lpresto_table$package$$anon$4() {
}
export { $h_Lpresto_table$package$$anon$4 as $h_Lpresto_table$package$$anon$4 };
$h_Lpresto_table$package$$anon$4.prototype = $p;
$p.zI = (function(item) {
  return false;
});
var $d_Lpresto_table$package$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_table$package$$anon$4, "presto.table$package$$anon$4", ({
  Y7: 1,
  cv: 1
}));
export { $d_Lpresto_table$package$$anon$4 as $d_Lpresto_table$package$$anon$4 };
//# sourceMappingURL=presto.table$package$$anon$4.js.map
